var React = require('react');

function Close (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Group_25","data-name":"Group 25","transform":"translate(-922.397 403.523)"},[React.createElement("path",{"id":"Path_15","data-name":"Path 15","d":"M325.5-324.152a48.145,48.145,0,0,1,5.994-.015c3.508.192,4.219.052,8.336.015s5.671-.015,5.671-.015","transform":"translate(464.551 -402.929) rotate(45)","fill":"none","stroke":"#131313","strokeLinecap":"round","strokeWidth":"2","key":0}),React.createElement("path",{"id":"Path_16","data-name":"Path 16","d":"M325.5-324.152a48.145,48.145,0,0,1,5.994-.015c3.508.192,4.219.052,8.336.015s5.671-.015,5.671-.015","transform":"translate(939.019 -861.359) rotate(135)","fill":"none","stroke":"#131313","strokeLinecap":"round","strokeWidth":"2","key":1})]));
}

Close.defaultProps = {"width":"17.216","height":"17.179","viewBox":"0 0 17.216 17.179"};

module.exports = Close;

Close.default = Close;
